import React from 'react'

import { Box, createStyles, WithStyles, withStyles } from '@material-ui/core'

interface Props extends WithStyles<typeof styles> {
  onClick: (e?: any) => void
}

const styles = () => createStyles({
  clickable: {
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
  },
})

const Clickable = (props: React.PropsWithChildren<Props>) => {
  const { onClick, children, classes } = props

  return <Box onClick={onClick} className={classes.clickable}>
    {children}
  </Box>
}

export default withStyles(styles)(Clickable)
